import { useMainStore } from '../stores/useMainStore.js'

let clientInstance = null

/**
 * Erstellt einen fetch-basierten API-Client
 */
function createFetchClient(baseURL, defaultHeaders = { } ) {
  return {
    async get(url, config = {}) {
      const response = await fetch(`${baseURL}${url}`, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          ...config.headers
        }
      })
      
      const data = await response.json()
      return {
        status: response.status,
        statusText: response.statusText,
        data,
        headers: response.headers
      }
    },
    
    async post(url, data, config = {}) {
      const response = await fetch(`${baseURL}${url}`, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          ...config.headers
        },
        body: JSON.stringify(data)
      })
      
      const responseData = await response.json()
      return {
        status: response.status,
        statusText: response.statusText,
        data: responseData,
        headers: response.headers
      }
    }
  }
}

/**
 * Gibt den API-Client zurück (Lazy Initialization).
 * Der Client wird beim ersten Aufruf erstellt und nutzt die Konfiguration aus dem MainStore.
 * @returns {Object}
 */
export function getApiClient() {
  if (!clientInstance) {
    const store = useMainStore()
    const baseURL = store.dataAttributes.apiUrl || ''
    
    if (!baseURL) {
      console.warn('apiUrl nicht in data-Attributen gefunden')
    }
    
    clientInstance = createFetchClient(baseURL, {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer 2|cwbMCuYdlIswTDFZ0Rt26y40j5zgNOBfwG1z56kcddbf4cbb',
    })
  }
  return clientInstance
  //Bearer ist vigo spezifisch
}

/**
 * Setzt den Client zurück (für Tests oder Widget-Reinitialisierung)
 */
export function resetApiClient() {
  clientInstance = null
}